(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winter-shawl-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const DECEL = 0.99; /* snappier than scroll's 0.998, so a short drag lands a card or two away */
    const project = (v) => (v / 1000) * DECEL / (1 - DECEL);
    const rubber = (over, dim, c = 0.55) => (over * dim * c) / (dim + c * Math.abs(over));
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

    function init(root) {
      if (!root || root._wsp) return;
      const ac = new AbortController();
      const opts = { signal: ac.signal };
      const observers = [];
      root._wsp = { destroy() { ac.abort(); observers.forEach((o) => o.disconnect()); root._wsp = null; } };

      const designMode = !!(window.Shopify && window.Shopify.designMode);
      root.setAttribute('data-js', '');

      /* ---- materialize + reveal, once. Stagger only within the batch that enters together ---- */
      const reveal = root.querySelectorAll('[data-mat],[data-reveal]');
      if (designMode || !('IntersectionObserver' in window)) {
        reveal.forEach((el) => el.classList.add('is-in', 'is-done'));
      } else {
        const io = new IntersectionObserver((entries) => {
          let k = 0;
          entries.filter((e) => e.isIntersecting).forEach((e) => {
            const el = e.target;
            const d = Math.min(k++, 5) * 60;
            if (d) el.querySelectorAll('img').forEach((i) => (i.style.transitionDelay = d + 'ms'));
            if (d && el.hasAttribute('data-reveal')) el.style.transitionDelay = d + 'ms';
            el.classList.add('is-in');
            io.unobserve(el);
            if (el.hasAttribute('data-mat')) {
              setTimeout(() => {
                el.classList.add('is-done');
                el.querySelectorAll('img').forEach((i) => (i.style.transitionDelay = ''));
              }, 1300 + d);
            }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
        observers.push(io);
        reveal.forEach((el) => io.observe(el));
        /* fail-safe: anything already on screen is shown even if the observer is late */
        window.addEventListener('load', () => setTimeout(() => reveal.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (!el.classList.contains('is-in') && r.bottom > 0 && r.top < innerHeight * 1.2 && r.right > 0 && r.left < innerWidth) el.classList.add('is-in', 'is-done');
        }), 1500), opts);
      }

      /* ---- phone film height: measure where the film really starts (announcement bar, header, masthead above it) ---- */
      const frameM = root.querySelector('.wsp-film-frame--m');
      if (frameM) {
        const measure = () => {
          if (!frameM.getClientRects().length) return;
          root.style.setProperty('--wsp-top', Math.max(0, Math.round(frameM.getBoundingClientRect().top + window.scrollY)) + 'px');
        };
        measure();
        window.addEventListener('resize', measure, opts);
        window.addEventListener('load', measure, opts);
        if (window.ResizeObserver) { const mro = new ResizeObserver(measure); mro.observe(document.body); observers.push(mro); }
      }

      /* ---- films: play only the variant that is on screen, only while visible, never under reduced motion ---- */
      const films = [...root.querySelectorAll('[data-wsp-film] video, .wsp-band video, .wsp-journey__video video')]
        .filter((v) => !v.controls && v.getClientRects().length > 0);
      if (films.length && !reduce() && 'IntersectionObserver' in window) {
        const fio = new IntersectionObserver((entries) => entries.forEach((e) => {
          if (e.isIntersecting) { e.target.muted = true; e.target.play().catch(() => {}); } else e.target.pause();
        }), { threshold: 0.25 });
        observers.push(fio);
        films.forEach((v) => fio.observe(v));
      }

      /* ---- offer: countdown + copy code ---- */
      root.querySelectorAll('[data-wsp-offer]').forEach((box) => {
        const wrap = box.closest('.wsp-offer-wrap');
        const endMs = Date.parse(box.dataset.end);
        const timer = box.querySelector('[data-wsp-timer]');
        const pad = (n) => String(n).padStart(2, '0');
        const endsLabel = (box.dataset.endsLabel || 'Ends in') + ' ';
        let id = 0;
        const tick = () => {
          if (Number.isNaN(endMs)) return false;
          const left = endMs - Date.now();
          if (left <= 0) { if (box.dataset.hide === 'true' && !designMode && wrap) wrap.hidden = true; if (timer) timer.textContent = ''; return false; }
          const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, sec = Math.floor(left / 1e3) % 60;
          if (timer) timer.textContent = d >= 1 ? `${endsLabel}${d}d ${h}h ${pad(m)}m` : `${endsLabel}${pad(h)}:${pad(m)}:${pad(sec)}`;
          return true;
        };
        if (tick()) { id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); observers.push({ disconnect() { clearInterval(id); } }); }

        const btn = box.querySelector('[data-wsp-copy]');
        const codeEl = box.querySelector('[data-wsp-code]');
        if (!btn || !codeEl) return;
        const label = btn.querySelector('[data-wsp-copy-label]');
        const status = box.querySelector('[data-wsp-status]');
        const code = codeEl.textContent.trim();
        const idleText = box.dataset.copyLabel || 'Copy code';
        const doneText = box.dataset.copiedLabel || 'Copied';
        let t = 0;
        const done = (ok) => {
          label.textContent = ok ? doneText : 'Copy failed';
          btn.classList.toggle('is-copied', ok);
          status.textContent = ok ? `Code ${code} copied` : 'Could not copy, select the code instead';
          if (ok && navigator.vibrate) navigator.vibrate(8);
          clearTimeout(t);
          t = setTimeout(() => { label.textContent = idleText; btn.classList.remove('is-copied'); }, 1800);
        };
        btn.addEventListener('click', async () => {
          try { await navigator.clipboard.writeText(code); done(true); }
          catch (err) {
            try {
              const ta = document.createElement('textarea');
              ta.value = code; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;opacity:0;font-size:16px';
              document.body.appendChild(ta); ta.select();
              const ok = document.execCommand('copy');
              ta.remove(); done(ok);
            } catch (err2) { done(false); }
          }
        }, opts);
      });

      /* ---- tabs: scroll-spy + sliding ink ---- */
      const bar = root.querySelector('[data-wsp-bar]');
      const tabsEl = root.querySelector('[data-wsp-tabs]');
      const ink = root.querySelector('[data-wsp-ink]');
      const tabs = tabsEl ? [...tabsEl.querySelectorAll('.wsp-tab')] : [];
      const sections = [...root.querySelectorAll('[data-wsp-section]')];
      if (bar && tabs.length) {
        const setBar = () => root.style.setProperty('--wsp-bar-offset', bar.offsetHeight + 'px');
        setBar();
        if (window.ResizeObserver) { const ro = new ResizeObserver(setBar); ro.observe(bar); observers.push(ro); }

        const moveInk = (tab) => {
          const t = tab.getBoundingClientRect(), p = tabsEl.getBoundingClientRect();
          ink.style.transform = `translateX(${t.left - p.left + tabsEl.scrollLeft}px) scaleX(${t.width / 100})`;
        };
        const setActive = (i, scrollTabs) => {
          if (!tabs[i]) return;
          tabs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
          moveInk(tabs[i]);
          if (scrollTabs) tabs[i].scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduce() ? 'auto' : 'smooth' });
        };
        if ('IntersectionObserver' in window) {
          const spy = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) setActive(sections.indexOf(e.target), true); });
          }, { rootMargin: '-35% 0px -55% 0px' });
          observers.push(spy);
          sections.forEach((s) => spy.observe(s));
        }
        tabs.forEach((t, i) => {
          t.addEventListener('click', (e) => {
            const target = root.querySelector(t.getAttribute('href'));
            if (!target) return;
            e.preventDefault();
            setActive(i, false);
            target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
          }, opts);
        });
        window.addEventListener('resize', () => moveInk(tabs.find((t) => t.getAttribute('aria-current') === 'true') || tabs[0]), opts);
        (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => setActive(0, false));
      }

      /* ---- rails: mouse drag 1:1, momentum projection, rubber band, critically damped spring.
              Touch keeps native scroll and snap. ---- */
      root.querySelectorAll('[data-wsp-rail]').forEach((rail) => {
        const track = rail.querySelector('.wsp-rail__track');
        const section = rail.closest('.wsp-collection');
        const thumb = section.querySelector('.wsp-progress__thumb');
        const [prev, next] = section.querySelectorAll('.wsp-arrow');
        const cards = [...track.children];
        if (!cards.length) return;
        let raf = 0, p = 0, drag = null, suppress = false;

        const max = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
        const snaps = () => {
          const base = cards[0].offsetLeft, m = max();
          const s = cards.map((c) => c.offsetLeft - base).filter((v) => v < m - 4);
          s.push(m);
          return s;
        };
        const nearest = (list, v) => list.reduce((best, c) => (Math.abs(c - v) < Math.abs(best - v) ? c : best), list[0]);
        function render(v) {
          p = v;
          const sl = clamp(v, 0, max());
          rail.scrollLeft = sl;
          track.style.transform = sl === v ? '' : `translate3d(${sl - v}px,0,0)`;
        }
        function ui() {
          const m = max(), sl = rail.scrollLeft;
          const ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
          if (thumb) thumb.style.transform = `translateX(${(m ? sl / m : 0) * (1 - ratio) * rail.clientWidth}px) scaleX(${ratio})`;
          if (prev) prev.setAttribute('aria-disabled', sl <= 2);
          if (next) next.setAttribute('aria-disabled', sl >= m - 2);
        }
        function stop() { cancelAnimationFrame(raf); raf = 0; }
        /* spring starts from the live on-screen value and inherits the release velocity */
        function springTo(target, v0 = 0, response = 0.45) {
          stop();
          if (reduce()) { render(target); ui(); return; }
          const w = (2 * Math.PI) / response;
          let x = p, v = v0, last = performance.now();
          const step = (now) => {
            const dt = Math.min((now - last) / 1000, 0.032);
            last = now;
            v += (-w * w * (x - target) - 2 * w * v) * dt;
            x += v * dt;
            render(x);
            if (Math.abs(x - target) < 0.3 && Math.abs(v) < 6) { render(target); ui(); raf = 0; return; }
            raf = requestAnimationFrame(step);
          };
          raf = requestAnimationFrame(step);
        }

        rail.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          const moving = !!raf;
          stop();
          if (!moving) p = rail.scrollLeft;
          drag = { x: e.clientX, start: p, live: false, hist: [{ t: e.timeStamp, p }], id: e.pointerId };
        }, opts);
        rail.addEventListener('pointermove', (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          const dx = e.clientX - drag.x;
          if (!drag.live) {
            if (Math.abs(dx) < 6) return; /* hysteresis before committing */
            drag.live = true;
            rail.setPointerCapture(e.pointerId);
            rail.classList.add('is-dragging');
          }
          const m = max(), raw = drag.start - dx;
          const v = raw < 0 ? -rubber(-raw, rail.clientWidth) : raw > m ? m + rubber(raw - m, rail.clientWidth) : raw;
          render(v);
          drag.hist.push({ t: e.timeStamp, p: v });
          if (drag.hist.length > 6) drag.hist.shift();
        }, opts);
        const end = (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          const d = drag;
          drag = null;
          rail.classList.remove('is-dragging');
          if (!d.live) return;
          suppress = true;
          setTimeout(() => (suppress = false), 0);
          const a = d.hist[0], b = d.hist[d.hist.length - 1];
          const v = (b.p - a.p) / (Math.max(1, b.t - a.t) / 1000); /* px/s, same sign as scroll position */
          const projected = clamp(p + project(v), 0, max());
          springTo(nearest(snaps(), projected), v);
        };
        rail.addEventListener('pointerup', end, opts);
        rail.addEventListener('pointercancel', end, opts);
        rail.addEventListener('click', (e) => { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, { capture: true, signal: ac.signal });
        rail.addEventListener('dragstart', (e) => e.preventDefault(), opts);
        rail.addEventListener('scroll', () => { if (!drag && !raf) p = rail.scrollLeft; requestAnimationFrame(ui); }, { passive: true, signal: ac.signal });

        [prev, next].forEach((btn) => btn && btn.addEventListener('click', () => {
          const want = clamp(rail.scrollLeft + Number(btn.dataset.dir) * rail.clientWidth * 0.8, 0, max());
          p = rail.scrollLeft;
          springTo(nearest(snaps(), want), 0, 0.5);
        }, opts));
        window.addEventListener('resize', ui, opts);
        window.addEventListener('load', ui, opts);
        ui();
      });
    }

    const boot = (scope) => (scope || document).querySelectorAll('[data-wsp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-wsp]').forEach((r) => r._wsp && r._wsp.destroy()));
  })();

  } catch(e) { console.error(e); }
})();
})();
